/**
 * Grid counts are integers of at least one — `repeat(2.5, 1fr)` and `span 0`
 * are invalid, and the browser drops the whole declaration.
 */
export const toTrackCount = (value: number): number | null => {
  const count = Math.floor(value);
  if (!Number.isFinite(count) || count < 1) return null;
  return count;
};
